import api from "./api";
import endpoints from "./endpoints";

export default {
  getTranslatedText: async function (text, sourceLanguage, targetLanguage) {
    const response = await api.post(endpoints.deepLTranslation.get, {
      text,
      sourceLanguage,
      targetLanguage
    });
    return response.data;
  }
};
